// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"3e115068","512":"86908add","523":"b0913872","859":"e8ca574e"}[chunkId] + ".chunk.js";
};